import loadDriver from './load-driver.js';

const constructPaymentLink = async (theapp, settings_entry, xtra_params) => {
	console.log('constructPaymentLink called');

	let mvcmywidget = theapp.getMvcMyWidget();
	let start_conditions = theapp.getStartConditions();

	if (!start_conditions)
	return;

	// find driver for specified wallet (if any)
	let remotewallet = await loadDriver(theapp);

	if (remotewallet) {
		let context = {};
		await theapp.getCurrencyContext(context, settings_entry);

		let _currency = context.currency;
		let _card = context.currentcard;
		let _scheme = context.currentscheme;

		let amount = (xtra_params ? xtra_params.amount : null);
		let to_address = (xtra_params ? xtra_params.to_address : null);

		let params = {amount: amount, to_address,  returnurl: start_conditions.caller, callbackurl: start_conditions.callbackurl};

		// currency context
		params.schemeuuid = (_scheme ? _scheme.uuid : null);
		params.web3_provider_url = (_scheme && _scheme.network && _scheme.network.ethnodeserver ? _scheme.network.ethnodeserver.web3_provider_url : null);

		params.carduuid = (_card ? _card.uuid : null);
		params.cardaddress = (_card ? _card.address : null);

		params.currencyuuid = (_currency ? _currency.uuid : null);
		params.currencyaddress = (_currency ? _currency.address : null);

		// transaction info (seller info, description, category,...)
		if (xtra_params)
		params = Object.assign(params, xtra_params);

		return remotewallet.getPaymentLink(params);

	}
}

export default constructPaymentLink;